import React from "react";
import '../../styling/RevenueInfoTile.css';

const RevenueInfoTile = ({tile}) => {
  let data = tile ;
  let totalEvents = 0;
  let totalPendingPayments = 0;
  let completedEvents = 0;
  let upcomingEvents = 0;

  if (Array.isArray(data) && data.length > 0 && Array.isArray(data[0]) && data[0].length > 0 && typeof data[0][0] === 'object') {
    // Access the values from the nested objects


    totalEvents = data[0][0]?.totalEvents || 0;
    totalPendingPayments = data[1][0]?.totalPendingPayments || 0;



    completedEvents = data[2][0]?.completedEvents || 0;
    upcomingEvents = data[3][0]?.upcomingEvents || 0 ;
  } 
  return (
    <div className="dashboard-details"
      style={{
        width: "100%",
        minHeight: "90px",
        background: "linear-gradient(to right, #1C1154, #260F99)",
        marginTop: "0px",
        display: "flex",
        borderRadius: '5px',
        boxShadow: "0px 3px 12px #00000029",
      }}
    >
      <div className="column">
        <p style={{ marginBottom: '0px' }}> Total Bookings</p>
        <h1>{totalEvents}</h1>
      </div>
      <div className="column">
        <p style={{ marginBottom: '0px' }} > Upcoming Bookings </p>
        <h1>{upcomingEvents}</h1>
      </div>
      <div className="column">
        <p style={{ marginBottom: '0px' }}> Completed Bookings</p>
        <h1>{completedEvents}</h1>
      </div>
      <div className="column" style={{ borderRight: 'hidden'}}>
        <p style={{ marginBottom: '0px' }}>Pending Payments</p>
        <h1>{totalPendingPayments}</h1>
      </div>
    </div>
  );
};

export default RevenueInfoTile;
